import { createFeatureActionNamer } from '../../../../../../../redux/action-name';

const getActionName = createFeatureActionNamer('underwriting-referrals');

export const ADD_UNDERWRITING_REFERRAL = getActionName('ADD_UNDERWRITING_REFERRAL');
export const UPDATE_UNDERWRITING_REFERRAL = getActionName('UPDATE_UNDERWRITING_REFERRAL');
export const DELETE_UNDERWRITING_REFERRAL = getActionName('DELETE_UNDERWRITING_REFERRAL');
